export { PosConfigurationLoyaltyTypes } from './posConfigurationLoyaltyTypes.component';
